var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99939 5.01963C8.00007 5.15061 7.97746 5.28046 7.93285 5.40172C7.88824 5.52298 7.82251 5.63327 7.73943 5.72627L4.15374 9.7073C4.07016 9.8001 3.97093 9.87371 3.86173 9.92393C3.75252 9.97415 3.63548 10 3.51728 10C3.39908 10 3.28203 9.97415 3.17283 9.92393C3.06362 9.87371 2.9644 9.8001 2.88082 9.7073C2.79724 9.61451 2.73094 9.50434 2.6857 9.3831C2.64047 9.26185 2.61719 9.1319 2.61719 9.00067C2.61719 8.86943 2.64047 8.73949 2.6857 8.61824C2.73094 8.497 2.79724 8.38683 2.88082 8.29403L5.84798 5.01963L2.99735 1.73528C2.90566 1.64372 2.83196 1.53215 2.78088 1.40753C2.7298 1.28291 2.70242 1.14793 2.70047 1.01103C2.69851 0.874125 2.72202 0.738248 2.76953 0.611895C2.81703 0.48554 2.8875 0.371429 2.97654 0.276695C3.06557 0.18196 3.17126 0.108641 3.28698 0.0613231C3.40271 0.0140046 3.52598 -0.00629339 3.64909 0.00169648C3.7722 0.00968636 3.8925 0.0457944 4.00247 0.107759C4.11244 0.169724 4.20971 0.256214 4.2882 0.361821L7.74839 4.34286C7.90645 4.52486 7.99619 4.76683 7.99939 5.01963Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalImg);
export default __webpack_public_path__ + "static/media/approval-Img.b4e0f98afa1fa0fe6d2f28c972a83cdb.svg";
export { ForwardRef as ReactComponent };